module.exports = __webpack_public_path__ + "static/come-on-b4e22378371b81efd4242849b3576a6d.gif";